let nav = document.getElementById('nav');
let dropdown = document.getElementById('dropdown');
let backdrop = document.getElementById('dropdown-backdrop');
let menuBtn = document.getElementById('menuBtn');

menuBtn.addEventListener("click", function() {
    toggle();
});

function toggle() {
    nav.classList.toggle('collapsed');
    setTimeout(function() {
        dropdown.classList.toggle('opacity');
    }, 250);
    dropdown.classList.toggle('collapsed');
    if (products && !products.classList.contains('collapsed')) {
        toggleProducts();
    }
}

// Close navbar when on the backdrop
backdrop.addEventListener('click', function(e) {
    if (!nav.classList.contains('collapsed')) {
        toggle();
    }
});

let products = document.getElementById('products');
let productsBtn = document.getElementById('productsBtn');
let navPadding = document.getElementById('navPadding');

if (productsBtn) {
    productsBtn.addEventListener("click", function() {
        toggleProducts();
    });
}

function toggleProducts() {
    products.classList.toggle('collapsed');
    navPadding.classList.toggle('padded');
}
